/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * * `AND` - AND
 * * `OR` - OR
 * @export
 */
export const LogicalOperatorEnum = {
    And: 'AND',
    Or: 'OR'
} as const;
export type LogicalOperatorEnum = typeof LogicalOperatorEnum[keyof typeof LogicalOperatorEnum];


export function instanceOfLogicalOperatorEnum(value: any): boolean {
    for (const key in LogicalOperatorEnum) {
        if (Object.prototype.hasOwnProperty.call(LogicalOperatorEnum, key)) {
            if (LogicalOperatorEnum[key as keyof typeof LogicalOperatorEnum] === value) {
                return true;
            }
        }
    }
    return false;
}

export function LogicalOperatorEnumFromJSON(json: any): LogicalOperatorEnum {
    return LogicalOperatorEnumFromJSONTyped(json, false);
}

export function LogicalOperatorEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): LogicalOperatorEnum {
    return json as LogicalOperatorEnum;
}

export function LogicalOperatorEnumToJSON(value?: LogicalOperatorEnum | null): any {
    return value as any;
}

export function LogicalOperatorEnumToJSONTyped(value: any, ignoreDiscriminator: boolean): LogicalOperatorEnum {
    return value as LogicalOperatorEnum;
}

